var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyTrafficIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "why-traffic-icon_svg__a",
    d: "M0 0h50.757v50.757H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "why-traffic-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#why-traffic-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.757 25.379c0 14.015-11.362 25.378-25.378 25.378C11.362 50.757 0 39.394 0 25.38 0 11.362 11.362-.001 25.379-.001c14.016 0 25.378 11.363 25.378 25.38",
    fill: "#F9D8CD",
    mask: "url(#why-traffic-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.558 17.818H10.193a2.546 2.546 0 00-2.545 2.545v42.001h67.456v-42a2.546 2.546 0 00-2.546-2.546",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.376 62.363h-2.545v-42c0-.702-.57-1.273-1.273-1.273H10.193c-.701 0-1.272.571-1.272 1.273v42H6.375v-42a3.823 3.823 0 013.818-3.819h62.365a3.823 3.823 0 013.818 3.819v42z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.195 62.363H49.65l-1.274 1.273H33.103l-1.273-1.273H1.284v2.546a3.83 3.83 0 003.818 3.818h71.274a3.818 3.818 0 003.819-3.818v-2.546z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.376 70H5.102a5.096 5.096 0 01-5.09-5.091v-3.818h32.345l1.273 1.272h14.219l1.274-1.272h32.344v3.818A5.096 5.096 0 0176.377 70zm-73.82-6.364v1.273a2.548 2.548 0 002.546 2.545h71.274a2.548 2.548 0 002.546-2.545v-1.273H50.177l-1.274 1.273H32.576l-1.273-1.273H2.557z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    d: "M20.375 58.545h6.364v-8.909h-6.364zM31.83 58.545h6.364V43.272H31.83zM43.285 58.545h6.364V29.272h-6.364zM54.74 58.545h6.363V38.181H54.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.012 58.545h-2.546V50.91h-3.818v7.636h-2.545V48.363h8.909zM39.467 58.545H36.92v-14h-3.818v14h-2.546V42h8.91zM50.921 58.545h-2.545v-28h-3.818v28h-2.546V28h8.91zM62.376 58.545h-2.545V39.454h-3.819v19.091h-2.545V36.908h8.91z"
  }))));
}
export default SvgWhyTrafficIcon;